/* EVENTS */
export const GET_CAR_BANNER = "GET_CAR_BANNER";
export const GET_CAR_BANNER_SUCCESS = "GET_CAR_BANNER_SUCCESS";
export const GET_CAR_BANNER_FAIL = "GET_CAR_BANNER_FAIL";

export const ADD_NEW_CAR_BANNER = "ADD_NEW_CAR_BANNER";
export const ADD_CAR_BANNER_SUCCESS = "ADD_CAR_BANNER_SUCCESS";
export const ADD_CAR_BANNER_FAIL = "ADD_CAR_BANNER_FAIL";

